<style>
.custom-link {
  color: #FF0000 !important;
}
</style>

<template>
<v-container class="form-container">
    <v-form ref="form" v-model="valid" @submit.prevent="submitForm">
        <v-row>
            <v-col class="pt-0" cols="12">
                <file-upload :projectId="projectId" @imageUploaded="handleImageUploaded" />
            </v-col>
            <v-col class="pt-0" cols="12">
                <p :style="{ color: '#' + labelColor }">{{ $t('form.fullName') }}</p>
                <v-text-field v-model="form.fullName" :rules="[rules.required]" :placeholder="$t('form.fullNamePlaceholder')" outlined dense></v-text-field>
            </v-col>
            <v-col class="pt-0" cols="12">
                <p :style="{ color: '#' + labelColor }">{{ $t('form.streetAddress') }}</p>
                <v-text-field v-model="form.street" :rules="[rules.required]" :placeholder="$t('form.streetAddressPlaceholder')" outlined dense></v-text-field>
            </v-col>
            <v-col class="pt-0" cols="12" md="6">
                <p :style="{ color: '#' + labelColor }">{{ $t('form.place') }}</p>
                <v-text-field v-model="form.place" :rules="[rules.required]" :placeholder="$t('form.placePlaceholder')" outlined dense></v-text-field>
            </v-col>
            <v-col class="pt-0" cols="12" md="6">
                <p :style="{ color: '#' + labelColor }">{{ $t('form.zipNumber') }}</p>
                <v-text-field v-model="form.zipNumber" :rules="[rules.required]" :placeholder="$t('form.zipNumberPlaceholder')" outlined dense></v-text-field>
            </v-col>
            <v-col class="pt-0" cols="12">
                <p :style="{ color: '#' + labelColor }">{{ $t('form.phoneNumber') }}</p>
                <v-text-field v-model="form.phone" :rules="[rules.required, rules.phoneNumber]" :placeholder="$t('form.phoneNumberPlaceholder')" outlined dense></v-text-field>
            </v-col>
            <v-col class="pt-0" cols="12">
                <p :style="{ color: '#' + labelColor }">{{ $t('form.email') }}</p>
                <v-text-field v-model="form.email" :rules="[rules.required, rules.email]" :placeholder="$t('form.emailPlaceholder')" outlined dense></v-text-field>
            </v-col>
            <v-col class="pt-0" cols="12">
                <p>
                    <input type="checkbox" v-model="form.agreeTermConditions">
                    <span :style="{ color: '#' + labelColor }">
                        {{ " " + $t('form.acceptTermsText') + " " }}
                    </span>
                    <a :href="terms" target="_blank" :style="{ color: '#' + buttonColor }">{{ $t('form.acceptTermsTextLink') }}</a>

                </p>
            </v-col>
        </v-row>
        <v-row v-if="!billNumImageUrlError" justify="center">
            <p class="error-message">{{ $t('billNumImageUrlError') }}</p>
        </v-row>
        <v-row v-if="!agreeTermConditionsError" justify="center">
            <p class="error-message">{{ $t('agreeTermConditionsError') }}</p>
        </v-row>
        <v-row v-if="!imageIsNotClearError" justify="center">
            <p class="error-message">{{ $t('imageIsNotClearError') }}</p>
        </v-row>
        <v-row justify="center" class="pt-5">
            <v-btn @click="submitForm" :loading="loading" :color="'#' + buttonColor" :style="{ color: 'white', width: '35%', borderRadius: '15px', fontSize: '18px'}">{{ $t('submit') }}</v-btn>
        </v-row>
    </v-form>
    <success-first-modal :show.sync="showModalFirst" :model="form" :projectId="projectId" />
    <success-modal :show.sync="showModal" :model="form" :projectId="projectId" />
</v-container>
</template>

<script>
import SuccessModal from './components/SuccessModalWithWerification';
import SuccessFirstModal from './components/SuccessModal';
import FileUpload from './components/FileUpload';
export default {
    components: {
        SuccessModal,
        SuccessFirstModal,
        FileUpload
    },
    props: {
        labelColor: {
            type: String,
            default: 'black',
        },
        buttonColor: {
            type: String,
            default: 'black',
        },
        projectId: {
            type: Number,
            default: 1,
        },
        lang: {
            type: String,
            default: 'hr',
        },
        terms: {
            type: String,
        },
    },
    data() {
        return {
            valid: true,
            billNumImageUrlError: true,
            agreeTermConditionsError: true,
            imageIsNotClearError: true,
            form: {
                fullName: '',
                street: '',
                place: '',
                zipNumber: '',
                phone: '',
                email: '',
                fileInput: null,
                imageUrl: '',
                agreeTermConditions: false,
            },
            rules: {
                required: value => !!value || this.$t('required'),
                email: value => /.+@.+\..+/.test(value) || this.$t('invalidEmail'),
                phoneNumber: value => /^385\d+/.test(value) || this.$t('invalidPhoneNumber'),
            },
            showModal: false,
            showModalFirst: false,
            user: {},
            loading: false,
            vecVerifikovan: false,
        };
    },
    created() {
        this.$i18n.locale = this.lang;
    },
    methods: {
        enter: function (event) {
            console.log('enter', event)
        },
        leave: function (event) {
            console.log('leave', event)
        },
        handleImageUploaded(imageUrl) {
            this.form.imageUrl = imageUrl;
        },
        async saveForm() {
            const url = 'https://sparkprize.azurewebsites.net/api/v2/formss/formentry';
            const authToken = 'eb0ce20e-1d0c-4154-acf8-3efec6130aa3';
            const user = "forms";
            const data = JSON.stringify({
                user: user,
                authToken: authToken,
                fullName: this.form.fullName,
                street: this.form.street,
                place: this.form.place,
                zipNumber: this.form.zipNumber,
                phone: this.form.phone,
                email: this.form.email,
                imgUrl: this.form.imageUrl,
                projectId: this.projectId,
            });

            try {
                const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                    },
                    body: data,
                })

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                const res = await response.json();
                if (res.PhoneVerified)
                    this.vecVerifikovan = true;

                this.loading = true;
                this.uploadReceipt();
            } catch (error) {
                console.error('Error:', error.message);
            }
        },
        submitForm() {
            if (this.$refs.form.validate()) {
                if (this.form.agreeTermConditions == true) {
                    this.agreeTermConditionsError = true;
                }
                if (this.form.agreeTermConditions == false) {
                    this.agreeTermConditionsError = false;
                } else if (this.form.imageUrl === '') {
                    this.billNumImageUrlError = false;
                } else {
                    this.billNumImageUrlError = true;
                    this.saveForm();
                }
            }
        },
        async updateUserData() {
            // Set up the request payload
            const payload = {
                idHexUser: this.user.phoneHex,
            };
            // Define the API URL
            const apiUrl = 'https://buychatbotapp-csekbeaxh7dmhjah.canadacentral-01.azurewebsites.net/api/users'; // Adjust the base URL as needed
            try {
                const response = await fetch(apiUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(payload)
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                const data = await response.json();
                // Update the user value with the response data
                this.user.userId = data.value;
                this.updateRetailerData();
            } catch (error) {
                console.error('Error:', error.message);
            }
        },
        async updateRetailerData() {
            const remappedData = {
                taxId: this.user.imgData.taxId || '',
                companyWeb: this.user.imgData.companyWeb || '',
                companyCountry: this.user.imgData.companyCountry || '',
                companyStates: this.user.imgData.companyStates || '',
                companyPostalCode: this.user.imgData.companyPostalCode || '',
                companyCity: this.user.imgData.companyCity || '',
                companyAptNum: this.user.imgData.companyAptNum || '',
                companyStreet: this.user.imgData.companyStreet || '',
                companyStreetAptNum: this.user.imgData.companyStreetAptNum || '',
                companyFullAddress: this.user.imgData.companyFullAddress || this.user.imgData.merchantAddress || '',
                companyName: this.user.imgData.companyName || '',
                companyBrandName: this.user.imgData.companyBrandName.replace(/['"]/g, '') || '',
                imageUrl: 'url'
            };

            // Define the API URL for POST request
            const apiUrl = 'https://buychatbotapp-csekbeaxh7dmhjah.canadacentral-01.azurewebsites.net/api/retailers'; // Replace with the actual URL

            try {
                const response = await fetch(apiUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(remappedData)
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                const data = await response.json();
                this.user.retailerId = data.value;
                this.createBusiness();
            } catch (error) {
                console.error('Error:', error.message);
            }
        },

        async createBusiness() {
            const remappedData = {
                retailerId: this.user.retailerId,
                name: this.user.imgData.companyBrandName || this.user.imgData.companyName || '',
                address: this.user.imgData.companyFullAddress || this.user.imgData.merchantAddress || '',
                city: this.user.imgData.companyCity || '',
                businessGeoLatitude: this.user.imgData.latitude || null,
                businessGeoLongitude: this.user.imgData.longitude || null,
                businessStreetAptNum: this.user.imgData.companyStreetAptNum || '',
                businessStreet: this.user.imgData.companyStreet || '',
                businessAptNum: this.user.imgData.companyAptNum || '',
                businessCity: this.user.imgData.companyCity || '',
                businessPostalCode: this.user.imgData.companyPostalCode || '',
                businessStates: this.user.imgData.companyStates || '',
                businessCountry: this.user.imgData.companyCountry || '',
                shopFormat: this.user.imgData.shopFormat || '',
                subBusiness: this.user.imgData.subBusiness || '',
                mall: this.user.imgData.mall || ''
            };

            // Define the API URL for POST request
            const apiUrl = 'https://buychatbotapp-csekbeaxh7dmhjah.canadacentral-01.azurewebsites.net/api/businesses';

            try {
                const response = await fetch(apiUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(remappedData)
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const responseData = await response.json();
                this.user.businessValue = responseData.value;
                this.submitReceiptData();
            } catch (error) {
                console.error('Error:', error.message);
            }
        },

        async submitReceiptData() {
            // Parse the transaction date from the user data
            const transactionDate = this.user.imgData.transactionDate; // The input string
            const [day, month, year] = transactionDate.split('.').map(Number);

            const transactionDateTime = new Date(year, month - 1, day); // Months are 0-based

            // Prepare receipt data
            const receiptData = {
                command: "CreateReceiptCommand",
                number: this.user.imgData.receiptNumber || '',
                transactionDateTime: transactionDateTime || null,
                amountTotal: this.user.imgData.ammountTotal || 0,
                userId: this.user.userId,
                receiptItems: this.user.imgData.items.map(item => ({
                    name: item.receiptItemName || null,
                    price: parseFloat(item.receiptItemPrice || 0),
                    quantity: parseFloat(item.quantityReceiptItem || 1),
                })),
                images: [{
                    path: this.user.imgData.imageBlobPath || null,
                }],
                retailerBusinessId: this.user.businessValue,
            };
            const apiUrl = 'https://buychatbotapp-csekbeaxh7dmhjah.canadacentral-01.azurewebsites.net/api/receipts';

            try {
                // Making the POST request using fetch
                const response = await fetch(apiUrl, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(receiptData), // Convert the receiptData to JSON string
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                // const responseData = await response.json();
            } catch (error) {
                console.error('Error:', error.message);
            }
        },

        async uploadReceipt() {
            try {
                const phoneString = this.form.phone;
                const phoneNumber = parseInt(phoneString, 10); // Convert string to number
                const phoneHex = phoneNumber.toString(16).toUpperCase(); // Convert to hex
                this.user.phoneHex = phoneHex;
                const url = 'https://api-geldocr-prod.azurewebsites.net/api/ReceiptOCR';
                const headers = {
                    Authorization: 'ApiKey 9d12780d-3445-4160-a20a-4343a4fac9d5',
                    'Content-Type': 'application/json'
                };
                const data = {
                    idHexUser: phoneHex,
                    projectId: this.projectId.toString(),
                    submitTimestamp: new Date().toISOString(),
                    imageReceiptPathCrUrl: this.form.imageUrl,
                    countryIdReceipt: 'HRV'
                };

                const response = await fetch(url, {
                    method: 'PUT',
                    headers: headers,
                    body: JSON.stringify(data)
                });

                if (!response.ok || response.status !== 201) {
                    this.imageIsNotClearError = false;
                    this.loading = false;
                    throw new Error('Network response was not ok');
                }

                const responseData = await response.json(); // Wait for the JSON response

                this.user.imgData = responseData;
                this.user.photoOk = true;
                this.loading = false;

                if (this.vecVerifikovan)
                    this.showModalFirst = true;
                else
                    this.showModal = true;

                this.updateUserData(); // Now it's called after the response is received
            } catch (error) {
                console.error('Error uploading receipt:', error);
            }
        }
    }
}
</script>
